import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject, zip } from 'rxjs';
import { map } from 'rxjs/operators';
import { AMapService } from '../../shared/amap.service';
import { PluginLoaderService } from '../../shared/plugin-loader.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { Getter } from '../../base/interfaces';
declare const AMap: any;

const TAG = 'AmapToolBar';

export namespace AMapToolBar {
  export interface Options {
    /**
     * ç¸å¯¹äºå°å¾å®¹å¨å·¦ä¸è§çåç§»é
     */
    offset?: AMap.Pixel;
    /**
     * æ§ä»¶åé ä½ç½®
     * LT:å·¦ä¸è§;
     * RT:å³ä¸è§;
     * LB:å·¦ä¸è§;
     * RB:å³ä¸è§;
     */
    position?: Position;
    /**
     * æ å°ºé®çæ¯å¦å¯è§
     */
    ruler?: boolean;
    /**
     * å®ä½å¤±è´¥åï¼æ¯å¦å¼å¯IPå®ä½
     */
    noIpLocate?: boolean;
    /**
     * æ¯å¦æ¾ç¤ºå®ä½æé®
     */
    locate?: boolean;
    /**
     * æ¯å¦ä½¿ç¨ç²¾ç®æ¨¡å¼
     */
    liteStyle?: boolean;
    /**
     * æ¹åé®çæ¯å¦å¯è§
     */
    direction?: boolean;
    /**
     * æ¯å¦èªå¨å®ä½ï¼å³å°å¾åå§åå è½½å®æåï¼æ¯å¦èªå¨å®ä½çç¨æ·æå¨å°ï¼ä»å¨æ¯æHTML5çæµè§å¨ä¸­ææ
     */
    autoPosition?: boolean;
    /**
     * èªå®ä¹å®ä½å¾æ ï¼å¼ä¸ºMarkerå¯¹è±¡
     */
    locationMarker?: AMap.Marker;
    /**
     * æ¯å¦ä½¿ç¨é«å¾·å®ä½sdkç¨æ¥è¾å©ä¼åå®ä½ææ
     */
    useNative?: boolean;
    // internal
    timeout?: number;
  }
  export type Position = 'LT' | 'RT' | 'LB' | 'RB';
}

@Injectable()
export class AmapToolBarService implements Getter<any> {
  private toolBar: any;
  private toolBar$ = new ReplaySubject<any>(1);

  constructor(
    private amaps: AMapService,
    private plugin: PluginLoaderService,
    private logger: LoggerService,
    private ngZone: NgZone,
  ) {}

  /**
   * è·åå·¥å·æ¡
   */
  get() {
    return this.toolBar$.asObservable();
  }

  /**
   * åå»ºå·¥å·æ¡ AMap.ToolBar
   * @param options éé¡¹
   */
  create(options: AMapToolBar.Options) {
    return zip(this.amaps.get(), this.plugin.load('AMap.ToolBar')).pipe(
      map(([m]) => {
        this.toolBar = this.ngZone.runOutsideAngular(() => new AMap.ToolBar(options));
        this.logger.d(TAG, 'new toolBar created.');
        m.addControl(this.toolBar);
        this.toolBar$.next(this.toolBar);
        this.toolBar$.complete();
        return this.toolBar;
      }),
    );
  }

  /**
   * éæ¯å·¥å·æ¡
   */
  destroy() {
    zip(this.amaps.get(), this.get()).subscribe(([m, toolBar]) => {
      m.removeControl(toolBar);
      this.logger.d(TAG, 'toolBar destroyed.');
      this.toolBar = null;
    });
  }
}
